<script setup>
import { uiText } from '../i18n'
defineProps({ eyebrow: String, title: String, subtitle: String })
</script>
<template>
  <header class="page-header">
    <div><p v-if="eyebrow" class="eyebrow">{{ uiText(eyebrow) }}</p><h1>{{ uiText(title) }}</h1><p v-if="subtitle" class="subtitle">{{ uiText(subtitle) }}</p></div>
    <slot />
  </header>
</template>

<style scoped>
/* 多视图复用组件：仅做中性弹性防护，长标题不挤压右侧槽位动作 */
.page-header > div { min-width: 0; }
</style>
